import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
    FormControl
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createChartOfAccount, getAccountsSimple, updateChartOfAccount } from '../api/apiAccountingConfiguration'
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';
import WrappedAutocomplete from 'common/components/custom/WrappedAutocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateChartOfAccount extends Component {

    emptyChartOfAccount = {
        isActive: false,
        account: '',
        description: '',
        allowedPostings: '',
        relatedAccountId: null
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialAccount: JSON.parse(JSON.stringify(this.emptyChartOfAccount)),
            chartOfAccount: JSON.parse(JSON.stringify(this.emptyChartOfAccount)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyChartOfAccount)),
            accounts: [],
            selectedRelatedAccount: null
        };
    }

    componentDidMount = () => {
        this.props.selectedClient && this.getAccountsSimple()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.chartOfAccountToEdit != null) {
            if (prevState.chartOfAccount.account !== this.props.chartOfAccountToEdit.account) {
                this.setState({
                    chartOfAccount: this.props.chartOfAccountToEdit,
                    initialAccount: JSON.parse(JSON.stringify(this.props.chartOfAccountToEdit)),
                    selectedRelatedAccount: this.state.accounts.find(a => a.id === this.props.chartOfAccountToEdit.relatedAccountId)
                });
            }
        }
    }

    getAccountsSimple = () => {
        getAccountsSimple(this.props.selectedClient.id).then((response) => {
            this.setState({ accounts: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            chartOfAccount: JSON.parse(JSON.stringify(this.emptyChartOfAccount)),
            selectedRelatedAccount: null
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { chartOfAccount } = this.state;

        chartOfAccount[name] = value;
        this.setState({ chartOfAccount: chartOfAccount })
    };

    handleChangeRelatedAccount = (account) => {
        let { chartOfAccount } = this.state
        if (account !== null) {
            chartOfAccount.relatedAccountId = account.id
            this.setState({ selectedRelatedAccount: account, chartOfAccount: chartOfAccount })
        } else {
            chartOfAccount.relatedAccountId = null
            this.setState({ selectedRelatedAccount: null, chartOfAccount: chartOfAccount })
        }
    }

    createOrUpdateChartOfAccount = (e) => {
        e.preventDefault();
        let { chartOfAccount } = this.state

        if (!this.validateForm()) {
            return;
        }

        const requestBodyCreate = {
            ...this.state.chartOfAccount,
            clientId: this.props.selectedClient.id
        }

        let action = this.props.chartOfAccountToEdit ? updateChartOfAccount : createChartOfAccount;
        action(this.props.chartOfAccountToEdit ? chartOfAccount : requestBodyCreate).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.chartOfAccountToEdit ? 'update_message' : 'create_message', { title: this.props.t('account') }), { variant: 'success' });
            this.closeDialog()
            this.props.getAccounts()
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("account_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.chartOfAccountToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('account') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { chartOfAccount } = this.state;
        let valid = true;
        if (!chartOfAccount.account
            || !chartOfAccount.description
            || !chartOfAccount.allowedPostings
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { chartOfAccount, accounts, selectedRelatedAccount, initialAccount } = this.state

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.chartOfAccountToEdit ? this.props.t("edit_account") : this.props.t("new_account")}</DialogTitle>
                <form onSubmit={this.createOrUpdateChartOfAccount} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            autoFocus
                                            label={"account"}
                                            name="account"
                                            onChange={this.handleChange}
                                            value={chartOfAccount.account}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"description"}
                                            name="description"
                                            onChange={this.handleChange}
                                            value={chartOfAccount.description}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"allowed_postings"}
                                            name="allowedPostings"
                                            onChange={this.handleChange}
                                            value={chartOfAccount.allowedPostings}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={"related_account"}
                                                placeholder={"related_account"}
                                                name="selectedRelatedAccount"
                                                value={selectedRelatedAccount || null}
                                                options={accounts}
                                                onChange={this.handleChangeRelatedAccount}
                                                getOptionLabel={option => option.account ? option.account + " -" + option.description : ""}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.account ? option.account + " -" + option.description : ""}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    {this.props.chartOfAccountToEdit !== null && <Grid item container>
                                        <WrappedFromControlLabel
                                            onChange={this.handleChange}
                                            name="isActive"
                                            checked={chartOfAccount.isActive}
                                            label={"active"}
                                        />
                                    </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.chartOfAccountToEdit ? (JSON.stringify(chartOfAccount) === JSON.stringify(initialAccount)) : !this.validateForm()}>
                            {this.props.chartOfAccountToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateChartOfAccount)));
